import React, { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Container } from '@boulevard/blvd-ui'
import { appRootStore } from '../../stores'
import { autorun } from 'mobx'

export const FbeAuth: React.FC = observer(() => {
  const fbeAuthStore = appRootStore.getFbeAuthStore()
  useEffect(
    autorun(() => {
      fbeAuthStore.init()
    })
  )

  return (
    <Container>
            Something went wrong...
    </Container>
  )
})
